import { type OnResizeOptions, onResize } from "@suse-o11y/on-resize";
import { useOnResize } from "@suse-o11y/use-on-resize";
import { useLayoutEffect, useState } from "react";

export type UseResizeObserverOptions = Pick<OnResizeOptions<unknown>, "debounce">;

export function useResizeObserver<TElement extends HTMLElement>(
	element: null | undefined | TElement,
	{ debounce }: UseResizeObserverOptions = {},
): null | DOMRectReadOnly {
	const [rect, setRect] = useState<null | DOMRectReadOnly>(null);

	useOnResize((_, { contentRect }) => setRect(contentRect), {
		node: element,
		debounce,
	});

	useLayoutEffect(() => {
		if (element == null) {
			return;
		}

		return onResize((_, { contentRect }) => setRect(contentRect), {
			node: element,
			debounce,
		});
	}, [element, debounce]);

	return rect;
}
